import React, { useEffect, useState } from 'react';

import { TabScreenWrapper } from '@components/General/TabScreen';
import { NovedadesExportAnalyticsHelper } from '@core/Analytics/NovedadesExportAnalyticsHelper';
import NovedadesInasistencias from '@components/Novedades/NovedadesInasistencias';
import NovedadesReporte from '@components/Novedades/NovedadesReporte';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import ExportNovedadesScreen from './ExportNovedadesScreen';

interface NovedadesScreenProps {
    org: Organization;
}

const NovedadesScreen: React.FC<NovedadesScreenProps> = ({org}) => {

    const [clickedScreen, setClickedScreen] = useState<string>('inasistencias')

    useEffect(() => {
        if (clickedScreen === "exportacion") {
            NovedadesExportAnalyticsHelper.trackTabShown();
        }
    }, [clickedScreen]);

    const exportFlaps: Flap[] = (org.newFlags?.NovedadesExportWeb || process.env.REACT_APP_IS_DEV === 'YES') ? [
        {
            id: 'exportacion',
            label: 'Exportar',
            content: <ExportNovedadesScreen orgID={org.id} timezone={org.timezone}/>
        },
    ] : [];

    const flaps: Flap[] = [
        {
            id: 'inasistencias',
            label: 'Inasistencias',
            content: <NovedadesInasistencias orgID={org.id} />
        },
        {
            id: 'reporte',
            label: 'Reporte', 
            content: <NovedadesReporte orgID={org.id} timezone={org.timezone}/>
        },
        ...exportFlaps,
    ];

    return (
        <TabScreenWrapper
            title="Novedades"
            subtitle="Gestion de todos los colaboradores"
            flaps={flaps}
            flag={org.newFlags?.QontactPointCreationWeb}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
};

export default NovedadesScreen
